import { segmentApi } from '@edulastic/api'

export const SPARKLE_SIZE = 26

// Marks the summary's own loader so page-level loader checks can ignore it.
export const SUMMARY_SPIN_CLASS = 'ai-summary-spin'

export const NO_DATA_MESSAGE =
  '- No data available for the current selection. Update filters or comparison options to view results.'

export const ERROR_MESSAGE =
  'Unable to load AI summary. Try refreshing or updating your filters.'

export const GENERATE_PROMPT = 'Generate quick summary of this report with AI'

export const GENERATE_ERROR_MESSAGE =
  'Unable to generate AI summary. Please try again.'

export const LOADING_TIP = 'Generating AI Summary, please wait...'

export const FEEDBACK_VALUES = {
  THUMB_UP: 'ThumbUp',
  THUMB_DOWN: 'ThumbDown',
}

export const parseSummary = (summary) => {
  if (!summary) return []

  return summary
    .split('\n')
    .map((line) => line.trim().replace(/^[-*+]\s+/, ''))
    .filter(Boolean)
}

export const trackAISummaryEvent = (userResponse, eventName = 'Feedback') => {
  segmentApi.genericEventTrack(eventName, {
    userResponse,
    featureName: 'AISummary',
    pagePath: window?.location?.pathname || '',
  })
}

export const trackGenerateSummaryClick = ({ reportType }) => {
  segmentApi.genericEventTrack(
    'ai_summary_generate_clicked',
    {
      report_name: reportType,
      report_url: window?.location?.pathname || '',
    },
    // User details (user id, role, ...) are requested in DAT-796.
    { attachUserData: true }
  )
}

/** Sync non-cryptographic hash for Segment PII (contextId / chip text). */
export const hashForSegment = (value) => {
  if (value == null || value === '') return undefined
  const str = String(value)
  let hash = 5381
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 33 + str.charCodeAt(i)) % 4294967296
  }
  return hash.toString(16).padStart(8, '0')
}
